{
  "name": "@archery-inc/webapp",
  "private": true,
  "version": "1.106.14",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "preview": "vite preview",
    "build": "tsc && vite build",
    "graphql:compile": "graphql-codegen",
    "graphql:watch": "graphql-codegen -w",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build --stats-json",
    "test": "vitest --run",
    "test:coverage": "vitest --run --coverage",
    "semantic-release": "semantic-release -e semantic-release-commit-filter -t 'v${version}'",
    "chromatic": "chromatic --only-changed --storybook-base-dir=./packages/webapp"
  },
  "dependencies": {
    "@apollo/client": "^3.9.6",
    "@archery-inc/design-system": "workspace:*",
    "@sentry/react": "^7.106.0",
    "@sentry/vite-plugin": "^5.4.0",
    "@stripe/stripe-js": "^3.1.0",
    "@tanstack/react-router": "^1.170.18",
    "@types/amplitude-js": "^8.16.5",
    "@types/firebase": "^3.2.1",
    "@types/lodash.debounce": "^4.0.9",
    "@types/uuid": "^10.0.0",
    "amplitude-js": "^8.21.9",
    "firebase": "^10.8.1",
    "graphql": "^16.8.1",
    "local-storage-fallback": "^4.1.2",
    "localforage": "^1.10.0",
    "lodash.debounce": "^4.0.8",
    "lottie-react": "^2.4.0",
    "match-sorter": "^6.3.4",
    "react-colorful": "^5.6.1",
    "react-hook-form": "^7.51.0",
    "react-qr-code": "^2.0.12",
    "sort-by": "^0.0.2",
    "uuid": "^11.1.1",
    "zustand": "^4.5.2"
  },
  "devDependencies": {
    "@babel/core": "^7.29.7",
    "@babel/plugin-transform-runtime": "^7.29.7",
    "@babel/runtime": "^7.29.7",
    "@graphql-codegen/cli": "^5.0.2",
    "@graphql-codegen/client-preset": "^4.2.4",
    "@graphql-typed-document-node/core": "^3.2.0",
    "@rolldown/plugin-babel": "^0.2.3",
    "@semantic-release/changelog": "^6.0.3",
    "@semantic-release/git": "^10.0.1",
    "@types/babel__core": "^7.20.5",
    "@vitejs/plugin-react": "^6.0.3",
    "babel-plugin-react-compiler": "^1.0.0",
    "semantic-release": "^23.0.2",
    "vite": "^8.1.5",
    "vite-plugin-pwa": "^1.3.0",
    "workbox-window": "^7.4.1"
  },
  "msw": {
    "workerDirectory": "public"
  }
}
